module.exports = window["MaterialUI"].InputAdornment;